
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/ipl/[slug]/info",
      function () {
        return require("private-next-pages/sports/ipl/[slug]/info/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/ipl/[slug]/info"])
      });
    }
  